module.exports = __webpack_public_path__ + "img/21.20c2f144.png";